import { defineModuleEvidenceContract, defineModuleEvidenceEntry } from './moduleEvidenceContract';
import { DECISION_AGENT_SOURCE_CLASSES } from './sourceClasses';

// origin/main literals: apps/api/src/decision-modules/productivity-lean-ai/
// productivity-lean-ai.data-lake-source.ts (PRODUCTIVITY_LEAN_AI_DATA_LAKE_CONTEXT_KIND,
// PRODUCTIVITY_LEAN_AI_DATA_LAKE_SCHEMA_VERSION_V2). The engine admits schema v1 OR
// v2 rows (schemaVersion: { in: [v1, v2] }); v2 is the current schema (adds the
// required glAccountRows member) and is what the freshest live evidence carries, so
// it is the version this single-schemaVersion contract entry pins. Confirmed live on
// tenant helix_retail 2026-08-06: 4 APPROVED, ingest-anchored v2 rows (modeled,
// latest approvedAt 2026-07-29, asOf 2026-06-30); older v1 rows also present
// (csv-admin-upload, modeled) but not the freshest.
export const PRODUCTIVITY_LEAN_AI_EVIDENCE_KEYS = {
  governedSnapshot: 'approved_productivity_realization_snapshot',
} as const;

export const PRODUCTIVITY_LEAN_AI_CONTEXT_KINDS = {
  governedSnapshot: 'decision_agent:productivity_lean_ai:governed_snapshot',
} as const;

export const PRODUCTIVITY_LEAN_AI_SCHEMA_VERSIONS = {
  manifest: 'decision_agent_module_manifest_v1',
  governedSnapshot: 'productivity_lean_ai_governed_snapshot_v2',
} as const;

const NO_PRODUCTIVITY_LEAN_AI_BINDING_PLACEHOLDERS: readonly string[] = Object.freeze([]);

const productivityLeanAiGovernedSnapshotEntry = defineModuleEvidenceEntry(
  PRODUCTIVITY_LEAN_AI_EVIDENCE_KEYS.governedSnapshot,
  {
    sourceClass: DECISION_AGENT_SOURCE_CLASSES.modeled,
    contextKind: PRODUCTIVITY_LEAN_AI_CONTEXT_KINDS.governedSnapshot,
    schemaVersion: PRODUCTIVITY_LEAN_AI_SCHEMA_VERSIONS.governedSnapshot,
    bindingPlaceholders: NO_PRODUCTIVITY_LEAN_AI_BINDING_PLACEHOLDERS,
    domain: 'operations',
    freshnessCadence: 'quarterly',
    // The module's own PRODUCTIVITY_LEAN_AI_EVIDENCE_POLICY declares
    // maxAgeHours: 2160 (90 days), staleBehavior: 'allow_with_gap' — a degrade
    // posture, not a hard block.
    requiredFor: ['ask_helix', 'decision_pack'],
    missingBehavior: 'degrade',
    description:
      'Approved productivity / Lean-AI governed realization snapshot (schema v2) published by the ' +
      "governed data-lake source; backs every productivity read/narration intent's " +
      'requiredEvidenceKeys entry of the same key.',
  },
);

export const PRODUCTIVITY_LEAN_AI_MODULE_EVIDENCE_CONTRACT = defineModuleEvidenceContract(
  'productivity-lean-ai',
  {
    governed_snapshot: productivityLeanAiGovernedSnapshotEntry,
  },
  {
    evidenceKeys: Object.values(PRODUCTIVITY_LEAN_AI_EVIDENCE_KEYS),
    sourceClasses: [DECISION_AGENT_SOURCE_CLASSES.modeled],
    contextKinds: Object.values(PRODUCTIVITY_LEAN_AI_CONTEXT_KINDS),
    schemaVersions: Object.values(PRODUCTIVITY_LEAN_AI_SCHEMA_VERSIONS),
    stateKeys: Object.values(PRODUCTIVITY_LEAN_AI_EVIDENCE_KEYS),
    bindingPlaceholders: NO_PRODUCTIVITY_LEAN_AI_BINDING_PLACEHOLDERS,
  },
);

export type ProductivityLeanAiModuleEvidenceContract =
  typeof PRODUCTIVITY_LEAN_AI_MODULE_EVIDENCE_CONTRACT;
